import axios from 'axios'

export default{
  getDegree(state, payload){

    axios.get(state.root + payload.degreeType + '/?slug=' + payload.degreeName)
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.viewDegree = []
        let q = response.data[0]
        console.log(q)
        //for(let i =0; i < 10; i++){
          let k = {}
          k.title = q.title['rendered']
          k.articleType = q.type
          k.slug = q.slug
          k.id = q.id
          k.date_created = q.date
          k.cover1 = q.acf.cover_image_1
          k.cover2 = q.acf.cover_image_2
          k.cover3 = q.acf.cover_image_3
          k.degree = q.acf.degree_name
          k.isprovisional = q.acf.isprovisional
          k.degreetype = q.acf.degree_type
          k.degreequote = q.acf.degree_quote
          k.emphasis_and_concentration = q.acf.emphasis_and_concentrations
          k.program_length = q.acf.program_length_
          k.degree_do_for_me = q.acf.degree_do_for_me.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
          k.matriculation_requirements = q.acf.matriculation_requirements.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*")
          k.provisional_requirements = q.acf.provisional_requirements.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*")
          k.what_you_leave_with = q.acf.what_you_leave_with.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*");
          k.emphasis = q.acf.emphasis
          k.department = q.acf.department
          if(q.acf.bachelor_arts === true ){
            k.degree_area = 'Bachelors of Arts'
          } else if(q.acf.bachelor_science === true){
            k.degree_area = 'Bachelors of Science'
          }else if(q.acf.associate_arts === true){
            k.degree_area = 'Associate of Arts'
          }else if(k.degree_area = 'Associate of Science'){
            k.degree_area = 'Associate of Science'
          }

          state.viewDegree.push(k)
        //}
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getGradDegree(state, payload){

    axios.get(state.root + payload.degreeType + '/?slug=' + payload.degreeName)
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.viewGradDegree = []
        let q = response.data[0]
        console.log(q)
        //for(let i =0; i < 10; i++){
        let k = {}
        k.title = q.title['rendered']
        k.articleType = q.type
        k.slug = q.slug
        k.id = q.id
        k.date_created = q.date
        k.cover1 = q.acf.cover_image_1
        k.cover2 = q.acf.cover_image_2
        k.cover3 = q.acf.cover_image_3
        k.degree = q.acf.degree_name
        k.degree_quote = q.acf.degree_quote
        k.degreetype = q.acf.degree_type
        k.isemphasis = q.acf.isemphasis
        k.completion_requirements = q.acf.completion_requirements
        k.emphasis_and_concentration = q.acf.emphasis_and_concentrations
        k.job_opportunities = q.acf.job_opportunities
        k.program_length = q.acf.program_length_
        k.degree_do_for_me = q.acf.degree_do_for_me.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
        k.matriculation_requirements = q.acf.matriculation_requirements.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*")
        k.class_schedule = q.acf.class_schedule.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*")
        k.what_you_leave_with = q.acf.what_you_leave_with.replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*");
        k.masters_arts = q.acf.masters_arts
        k.masters_of_business = q.acf.masters_of_business
        k.masters_of_science = q.acf.masters_of_science
        k.masters_of_ph = q.acf.masters_of_ph
        k.doctorial = q.acf.doctorial
        state.viewGradDegree.push(k)
        //}
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  AllUndergradDegrees(state, payload){
    axios.get(state.root + 'u_programs?per_page=50&filter[orderby]=date&order=asc&orderby=slug') //?per_page=10
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.undergradDegrees = []
        let q = response.data
        console.log(q)
        for(let i =0; i < q.length; i++){
          let k = {}
          k.title = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.degree_name = q[i].acf.degree_name
          k.associate_arts = q[i].acf.associate_arts
          k.associate_science = q[i].acf.associate_science
          k.bachelor_arts = q[i].acf.bachelor_arts
          k.bachelor_science = q[i].acf.bachelor_science
          k.emphasis = q[i].acf.emphasis
          k.department = q[i].acf.department
          console.log(k.bachelor_degree)
          k.job_application = q[i].acf.job_application

          state.undergradDegrees.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  AllGradDegrees(state, payload){
    axios.get(state.root + 'g_programs?per_page=50&filter[orderby]=date&order=asc&orderby=slug')
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.gradDegrees = []
        let q = response.data
        console.log(q)
        for(let i =0; i < q.length; i++){
          let k = {}
          k.title = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.degree_name = q[i].acf.degree_name
          k.masters_arts = q[i].acf.masters_arts
          k.department = q[i].acf.department
          k.masters_of_business = q[i].acf.masters_of_business
          k.masters_of_science = q[i].acf.masters_of_science
          k.masters_of_ph = q[i].acf.masters_of_ph
          k.doctorial = q[i].acf.doctorial

          k.job_application = q[i].acf.job_application

          state.gradDegrees.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  AllCareers(state, payload){
      axios.get(state.newRootUrl + 'jobs?per_page=30')
          .then(response => {


          state.AllJobsList =[]
          state.AllJobsList = response.data
          /*for (let i = 0; i < response.data.Jobs.length; i++){
              console.log(response.data.Jobs[i])
            state.AllJobsList.push(response.data.Jobs[i])
          }*/
      })
      .catch(err => {
        console.log('2')
      })
 /*   axios.get(state.root + 'careers')
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.careers = []
        let q = response.data
        console.log(q)
        for(let i =0; i < 10; i++){
        let k = {}
        k.title = q[i].title['rendered']
        k.articleType = q[i].type
        k.slug = q[i].slug
        k.id = q[i].id
        k.date_created = q[i].date
        k.application_deadline = q[i].acf.application_deadline
        k.department_name = q[i].acf.department_name
        k.job_title = q[i].acf.job_title
        k.job_application = q[i].acf.job_application

        state.careers.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });*/
  },
  getFeatures(state, payload){
    axios({
      method: 'get',
      url:  state.newRootUrl + 'feature-stories?per_page=4',
      //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
    })
      .then(response => {
        console.log(response.data)
        if (response.status === 200 ){
          //context.commit('setFeatureStoriesList', response.data)

          state.FeatureStoriesList =[]
          for (let i = 0; i < 10; i++){
            state.FeatureStoriesList = response.data
          }
        }
        else{
          console.log('1')
        }
      })
      .catch(err => {
        console.log('2')
      })
   /* axios.get(state.root + 'featurestories')
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data
        state.featureStories = []
        console.log(q)
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        for(let i =0; i < 10; i++){
          let k = {}
          k.feature_title = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.feature_image = q[i].acf.feature_image
          k.feature_thumb = q[i].acf.feature_thumb
          k.supporting_paragraph = q[i].acf.supporting_paragraph
          k.feature_article = q[i].acf.feature_article.replace(/(<p[^>]+?>|<p>)/img, "")
          k.feature_article = k.feature_article.replace(/(<\/p>)/img, "*")
          k.formattedArticle = k.feature_article.split('*')
          k.formattedArticle.pop()
          k.writers_name = q[i].acf.writers_name
          //k.paragraph3 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
          //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
          state.featureStories.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });*/
  },
  getAllFeatures(state, payload){
    axios({
      method: 'get',
      url:  state.newRootUrl + 'feature-stories?per_page=100',
      //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
    })
      .then(response => {
        console.log(response.data)
        if (response.status === 200 ){
          //context.commit('setFeatureStoriesList', response.data)

          state.featureStoriesAll = [];
          state.featureStoriesAll = response.data;
        }
        else{
          console.log('1')
        }
      })
      .catch(err => {
        console.log('2')
      })
  },
  getFeature(state, payload){
    //this.$router.push({'path': '/app'})
    //router.push({ path: '/article', query: { plan: 'private' }})
    /*console.log("-------------")
    console.log(payload)
    console.log("--------------")*/
    axios({
      method: 'get',
      url: state.newRootUrl + `feature-stories?slug=${payload.featureID}`,
      //headers: {'Authorization': 'Bearer ' + Vue.localStorage.get('token')},
      data: {
        featureID: payload.featureID
      }
    })
      .then(response => {

        if (response.status === 200) {
          state.FeatureStory ={}
          state.FeatureStory = response.data[0]
        } else {
          //reject(err)
        }
      })
      .catch(err => {
        console.log('2')
      })
    /*axios.get(state.root + payload.articleType + '/?slug=' + payload.articleName)
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.featureStory = []
        let q = response.data
        console.log(q)
        for(let i =0; i < 10; i++){
          let k = {}
          k.title = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.feature_image = q[i].acf.feature_image
          k.supporting_paragraph = q[i].acf.supporting_paragraph
          k.feature_article = q[i].acf.feature_article.replace(/(<p[^>]+?>|<p>)/img, "")
          k.feature_article = k.feature_article.replace(/(<\/p>)/img, "*")
          k.formattedArticle = k.feature_article.split('*')
          k.formattedArticle.pop()
          k.writers_name = q[i].acf.writers_name
          //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
          state.featureStory.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });*/
  },
  getArticles(state, payload){
    axios.get(state.news_root + '/newsarticles')
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data
        state.newsArticleSlide = []
        console.log(q)
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        for(let i =0; i < 10; i++){
          let k = {}
          k.title = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.paragraph1 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>|<\/p>)/img, ""); //remove p tags
          k.articleImage = q[i].acf.articlecoverimage
          k.paragraph2 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
          k.articleImage1 = q[i].acf.article_image_1
            console.log(k)
          //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
          state.newsArticleSlide.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getArticle(state, payload){
    //this.$router.push({'path': '/app'})
    //router.push({ path: '/article', query: { plan: 'private' }})
    console.log(payload)
    axios.get(state.news_root + '/' + payload.articleType + '/?slug=' + payload.articleName)
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.viewArticle = []
        let q = response.data
        console.log(q)
        for(let i =0; i < 10; i++){
          let k = {}
          k.articleTitle = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.paragraph1 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>)/img, "").replace(/(<\/p>)/img, "*").split('*'); //remove p tags
          k.articleImage = q[i].acf.articlecoverimage
          k.paragraph2 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
          k.articleImage1 = q[i].acf.article_image_1
          k.writer = q[i].acf.writer

          //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
          state.viewArticle.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getSportArticles(state){
    axios.get(state.news_root + '/sportsarticles')
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data
        state.sportsArticleSlide = []
        console.log(q)
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        for(let i =0; i < 10; i++){
          let k = {}
          k.title = q[i].title['rendered']
          k.articleType = q[i].type
          k.slug = q[i].slug
          k.id = q[i].id
          k.date_created = q[i].date
          k.paragraph1 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>|<\/p>)/img, ""); //remove p tags
          k.articleImage = q[i].acf.articlecoverimage
          k.paragraph2 = q[i].acf.article_paragraph_1.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
          k.articleImage1 = q[i].acf.article_image_1
          k.paragraph3 = q[i].acf.article_paragraph_2.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "")
          //state.newsArticleSlide = { ...state.newsArticleSlide, logo: response.data[0].acf.ncu_media, alka: 'sjdbhfv' }
          state.sportsArticleSlide.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getUpcomingEvents(state, payload){
    axios.get(state.strapiApi + 'extension-offerings')
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data
        state.upcomingEvents = []
        console.log(q)
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        for(let i =0; i < 10; i++){
          let k = {}


          k.slug = q[i].slug
          k.event_thumb = q[i].acf.event_thumb
          k.id = q[i].id
          k.date_created = q[i].date
          k.event_image = q[i].acf.event_image

          state.upcomingEvents.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getUpcomingEvent(state, payload){
    axios.get(state.root + 'upcomingevents/?slug=' + payload.slug)
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data
        state.upcomingEvent = []
        console.log(q)
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        //for(let i =0; i < 10; i++){
          let k = {}


          k.slug = q[0].slug
          k.id = q[0].id
          k.date_created = q[0].date
          k.event_image = q[0].acf.event_image

          state.upcomingEvent.push(k)
        //}
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  getAllEvents(state, payload){
    console.log(state.month[state.d.getMonth() ])
    let v = state.month[state.d.getMonth()].split('_')
    axios.get(state.root + 'events/?slug=' +  v[0] + '-' + v[1])
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data[0].acf
        // /state.upcomingEvents = []
        console.log(q)

        state.dayIndex = q.first_day
        //console.log(q.prevmonthdays - q.first_day)
        let trailer = q.prevmonthdays - q.first_day

        let l = []

        for (let i = 0; i < q.first_day; i++){
          //console.log(trailer + i)
          let x = {
            eventDay: (trailer + i) + 1,
            eventClass: 'shades'
          }
          l.push(x)
        }
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        // if(state.month[state.d.getMonth()] === 'february_2019'){
        state.eventsCalendar[state.monthTracker[1]] = []

        if(state.d.getMonth() === 11){
          state.monthTracker = [ state.month[state.d.getMonth() -1],  state.month[state.d.getMonth()], state.month[0], ]
        }else {
          state.monthTracker = [ state.month[state.d.getMonth() -1],  state.month[state.d.getMonth()], state.month[state.d.getMonth() + 1], ]
        }

        //k.currentMonth = state.monthTracker.currentMonth
       // console.log(q.currentmonthlength)
        for(let i = 0; i < q.currentmonthlength; i++){
          let k = {}

          //console.log(i)
          //console.log(state.month[state.d.getMonth()])
          k.weekday = state.days[state.dayIndex]
          if (state.dayIndex >= 6 ){
            state.dayIndex = 0
          }
          else {
            state.dayIndex++
          }
          k.eventDay = i + 1

          //console.log(q.first_day)
          //console.log(q[i + 1] )
          if(q[i + 1] !== ""){
            k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
            k.eventDetail.pop()
            k.eventClass = 'shadez'
            l.push(k)
            //console.log(l.length)
            if (l.length === 7){
              //console.log("full")
              state.eventsCalendar[state.month[state.d.getMonth()]].push(l)
              l = []
            }
          }else {
            k.eventDetail = ""
            k.eventClass = 'shade'
            l.push(k)
            // console.log(l.length)
            if (l.length === 7){
              // console.log("full")
              state.eventsCalendar[state.month[state.d.getMonth()]].push(l)
              l = []
            }
          }
          if (i >= q.currentmonthlength - 1){
            state.eventsCalendar[state.month[state.d.getMonth()]].push(l)
            l = []

          }

        }
        //}

      })
      .catch(function (error) {
        console.log(error);
      });

  },
  getNewEvents(state, payload){

    console.log(state.month[payload.monthIndex])
    let v = state.month[payload.monthIndex].split('_')
    //console.log(v[0] + '-' + v[1])
    axios.get(state.root + 'events/?slug=' +  v[0] + '-' + v[1])
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data[0].acf
        // /state.upcomingEvents = []
        console.log(q)
        state.dayIndex = q.first_day
        let l =[]
        let trailer = q.prevmonthdays - q.first_day
        //console.log(trailer)
        //let l = []

        for (let i = 0; i < q.first_day; i++){
          console.log(trailer + i + 1)
          let x = {
            eventDay: (trailer + i) + 1,
            eventClass: 'shades'
          }
          l.push(x)
        }
        //console.log(state.month[payload.monthIndex])
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        //if(state.month[payload.monthIndex] === 'february_2019'){
        state.monthTracker = []
          console.log(state.monthIndex)
        if(payload.monthIndex === 0){
          state.monthTracker = [ state.month[11],  state.month[payload.monthIndex], state.month[1], ]
        }
        else if(payload.monthIndex === 11){
          state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[0], ]
        }else
        {
          state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[payload.monthIndex +1], ]
        }


        state.eventsCalendar[state.monthTracker[1]] = []
        //state.eventsCalendar[state.monthTracker[1]] = []
        //state.monthTracker = [ state.month[state.d.getMonth() -1],  state.month[state.d.getMonth()], state.month[state.d.getMonth() +1], ]

        for(let i = 0; i < q.currentmonthlength; i++){
          console.log(i)
          let k = {}
          //console.log(state.month[state.d.getMonth()])

          k.weekday = state.days[state.dayIndex]
          if (state.dayIndex >= 6 ){
            state.dayIndex = 0
          }
          else {
            state.dayIndex++
          }
          k.eventDay = i + 1
          //console.log(i)
          //console.log(q[i + 1] )
          if(q[i + 1] !== ""){
            k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
            k.eventDetail.pop()
            k.eventClass = 'shadez'
            l.push(k)
            //console.log(l.length)
            if (l.length === 7){
              state.eventsCalendar[state.month[payload.monthIndex]].push(l)
              l = []
            }
          }else {
            k.eventDetail = ""
            k.eventClass = 'shade'
            l.push(k)
            //console.log(l.length)
            if (l.length === 7){
              state.eventsCalendar[state.month[payload.monthIndex]].push(l)
              l = []
            }
          }
          if (i >= q.currentmonthlength - 1){
            state.eventsCalendar[state.month[payload.monthIndex]].push(l)
            l = []

          }

        }
        //}
      })
      .catch(function (error) {
        console.log(error);
      });

  },
  getAllAcademicEvents(state, payload){
    //console.log(state.month[state.d.getMonth() ])
    let v = state.month[state.d.getMonth()].split('_')
    axios.get(state.root + 'academicevents/?slug=' +  v[0] + '-' + v[1])
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data[0].acf
        // /state.upcomingEvents = []
        console.log(q)

        state.dayIndex = q.first_day
        //console.log(q.prevmonthdays - q.first_day)
        let trailer = q.prevmonthdays - q.first_day

        let l = []

        for (let i = 0; i < q.first_day; i++){
          //console.log(trailer + i)
          let x = {
            eventDay: (trailer + i) + 1,
            eventClass: 'shades'
          }
          l.push(x)
        }
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
       // if(state.month[state.d.getMonth()] === 'february_2019'){
          state.academicCalendar[state.monthTracker[1]] = []
        if(state.d.getMonth() === 11) {
          state.monthTracker = [state.month[state.d.getMonth() - 1], state.month[state.d.getMonth()], state.month[0],]
        } else {
          state.monthTracker = [state.month[state.d.getMonth() - 1], state.month[state.d.getMonth()], state.month[state.d.getMonth() + 1],]
        }

          //k.currentMonth = state.monthTracker.currentMonth
        console.log(q.currentmonthlength)
          for(let i = 0; i < q.currentmonthlength; i++){
            let k = {}

            console.log(i)
            //console.log(state.month[state.d.getMonth()])
            k.weekday = state.days[state.dayIndex]
            if (state.dayIndex >= 6 ){
              state.dayIndex = 0
            }
            else {
              state.dayIndex++
            }
            k.eventDay = i + 1

            //console.log(q.first_day)
            //console.log(q[i + 1] )
            if(q[i + 1] !== ""){
              k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
              k.eventDetail.pop()
              k.eventClass = 'shadez'
              l.push(k)
              //console.log(l.length)
              if (l.length === 7){
                //console.log("full")
                state.academicCalendar[state.month[state.d.getMonth()]].push(l)
                l = []
              }
            }else {
              k.eventDetail = ""
              k.eventClass = 'shade'
              l.push(k)
             // console.log(l.length)
              if (l.length === 7){
               // console.log("full")
                state.academicCalendar[state.month[state.d.getMonth()]].push(l)
                l = []
              }
            }
            if (i >= q.currentmonthlength - 1){
                state.academicCalendar[state.month[state.d.getMonth()]].push(l)
                l = []

            }

          }
        //}

      })
      .catch(function (error) {
        console.log(error);
      });

  },
  getNewAcademicEvents(state, payload){


    let v = state.month[payload.monthIndex].split('_')
    console.log(v)
    axios.get(state.root + 'academicevents/?slug=' +  v[0] + '-' + v[1])
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        let q = response.data[0].acf
        // /state.upcomingEvents = []
        console.log(q)
        state.dayIndex = q.first_day
        let l =[]
        let trailer = q.prevmonthdays - q.first_day
        //console.log(trailer)
        //let l = []

        for (let i = 0; i < q.first_day; i++){
          console.log(trailer + i + 1)
          let x = {
            eventDay: (trailer + i) + 1,
            eventClass: 'shades'
          }
          l.push(x)
        }
        //console.log(state.month[payload.monthIndex])
        //state.siteLogo = { ...state.siteLogo, logo: response.data[0].acf.ncu_media }
        //if(state.month[payload.monthIndex] === 'february_2019'){
          state.monthTracker = []
        if(payload.monthIndex === 0){
          state.monthTracker = [ state.month[11],  state.month[payload.monthIndex], state.month[1], ]
        }
        else if(payload.monthIndex === 11){
            state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[0], ]
          }else
          {
            state.monthTracker = [ state.month[payload.monthIndex -1],  state.month[payload.monthIndex], state.month[payload.monthIndex +1], ]
          }


          state.academicCalendar[state.monthTracker[1]] = []


          for(let i = 0; i < q.currentmonthlength; i++){
          console.log(i)
            let k = {}
            //console.log(state.month[state.d.getMonth()])

            k.weekday = state.days[state.dayIndex]
            if (state.dayIndex >= 6 ){
              state.dayIndex = 0
            }
            else {
              state.dayIndex++
            }
            k.eventDay = i + 1
            //console.log(i)
            //console.log(q[i + 1] )
            if(q[i + 1] !== ""){
              k.eventDetail = q[i + 1].replace(/(<ul[^>]+?>|<ul>|<\/ul>)/img, "").replace(/(<li[^>]+?>|<li>)/img, "").replace(/(<\/li>)/img, "*").split('*')
              k.eventDetail.pop()
              k.eventClass = 'shadez'
              l.push(k)
               //console.log(l.length)
              if (l.length === 7){
                state.academicCalendar[state.month[payload.monthIndex]].push(l)
                l = []
              }
            }else {
              k.eventDetail = ""
              k.eventClass = 'shade'
              l.push(k)
              //console.log(l.length)
              if (l.length === 7){
                state.academicCalendar[state.month[payload.monthIndex]].push(l)
                l = []
              }
            }
            if (i >= q.currentmonthlength - 1){
              state.academicCalendar[state.month[payload.monthIndex]].push(l)
              l = []

            }

          }
        //}
      })
      .catch(function (error) {
        console.log(error);
      });

  },
  AllExtensionDegrees(state, payload){
    axios.get(state.root + 'https://www.ncu.edu.jm/manage/wp-json/wp/v2/extensiondegrees?per_page=50&filter[orderby]=date&order=asc&orderby=slug') //?per_page=10
      .then(function (response) {
        //console.log(response.data[0].acf.ncu_media)
        state.extensionDegrees = []
        let q = response.data
        console.log(q)
        for(let i =0; i < q.length; i++){
          let k = {}
          k.title = q[i].title['rendered']
          k.slug = q[i].slug
          k.id = q[i].id
          k.day = q[i].acf.day
          k.evening = q[i].acf.evening
          k.online = q[i].acf.online
          k.degree_name = q[i].acf.degree_name
          k.eastern = q[i].acf.eastern_campus
          k.western = q[i].acf.western_campus
          k.asc = q[i].acf.asc
          k.bsc = q[i].acf.bsc
          k.ba = q[i].acf.ba
          k.aa = q[i].acf.masters
          k.phd = q[i].acf.phd

          state.extensionDegrees.push(k)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  CareersSnip(state, payload){
    axios({
      method: 'get',
      url: state.rootUrl + 'getJobs',
      //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
    })
      .then(response => {
        console.log(response.data.Jobs.length)
        if (response.status === 201 ){
          state.JobsList =[]
          ////////////////////////////////////// Dalton couldn't figure out how to make this work
          let arrLen = function () {
            if(response.data.Jobs.length < 4){
              return response.data.Jobs.length
            }
            else if (response.data.Jobs.length >= 4){
              return 4
            }
          }
          for (let i = 0; i< arrLen(); i++){
            state.JobsList.push(response.data.Jobs[i])
          }
          //////////////////////////////////////
        }
        else{
          console.log('1')
        }
      })
      .catch(err => {
        console.log('2')
      })

  },

  setCurrentMonth(state, payload){
    state.currentMonthArray = []
    state.currentMonth["month"] = payload[0].month
    state.currentMonth["year"] = payload[0].year
    state.currentMonth["days"] = payload[0].days
    state.currentMonth["monthName"] = payload[0].monthName
    state.currentMonth["startOffset"] = payload[0].startOffset
    state.currentMonth["monthYearName"] = payload[0].monthYearName
    state.currentMonth["events"] = payload[0].events
    state.currentMonth["academics"] = payload[0].academics
    state.currentEventsList = []
    if (payload[0].events){
      for (let s = 0; s < payload[0].events.length; s++){
        state.currentEventsList.push(payload[0].events[s])
      }
    }
    let count = 0;
    let arrayPointer = 0
    state.currentMonthArray[arrayPointer] = []
    let monthNum = 0
    if(state.currentMonth.startOffset > 0){

      //state.currentMonthArray[arrayPointer] = []
      for(let j = 0; j < state.currentMonth.startOffset; j++){
        //console.log(state.currentMonthArray[arrayPointer])
        state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "blank",
            day: ''
        })
        count++
      }
      //state.currentMonthArray[arrayPointer] = []
      for(let i = 0; i < state.currentMonth.days; i++){
        //console.log(count % 7 === 0)
        if (count < 7){
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }else if (count % 7 === 0){
          arrayPointer++
          state.currentMonthArray[arrayPointer] = []
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        } else{
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }
      }
    }else{

      state.currentMonthArray[arrayPointer] = []
      for(let i = 0; i < state.currentMonth.days; i++){
        //console.log(count % 7 === 0)
        if (count < 7){
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }else if (count % 7 === 0){
          arrayPointer++
          state.currentMonthArray[arrayPointer] = []
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        } else{
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }
      }
    }
  },
  setAcademicCurrentMonth(state, payload){
    state.currentMonthArray = []
    state.currentMonth["month"] = payload[0].month
    state.currentMonth["year"] = payload[0].year
    state.currentMonth["days"] = payload[0].days
    state.currentMonth["monthName"] = payload[0].monthName
    state.currentMonth["startOffset"] = payload[0].startOffset
    state.currentMonth["monthYearName"] = payload[0].monthYearName
    state.currentMonth["events"] = payload[0].events
    state.currentMonth["academics"] = payload[0].academics
    state.currentAcademicsList = []
    if (payload[0].academics){
      for (let s = 0; s < payload[0].academics.length; s++){
        state.currentAcademicsList.push(payload[0].academics[s])
      }
    }
    let count = 0;
    let arrayPointer = 0
    state.currentMonthArray[arrayPointer] = []
    let monthNum = 0
    if(state.currentMonth.startOffset > 0){

      //state.currentMonthArray[arrayPointer] = []
      for(let j = 0; j < state.currentMonth.startOffset; j++){
        //console.log(state.currentMonthArray[arrayPointer])
        state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "blank",
            day: ''
        })
        count++
      }
      //state.currentMonthArray[arrayPointer] = []
      for(let i = 0; i < state.currentMonth.days; i++){
        //console.log(count % 7 === 0)
        if (count < 7){
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }else if (count % 7 === 0){
          arrayPointer++
          state.currentMonthArray[arrayPointer] = []
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        } else{
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }
      }
    }else{

      state.currentMonthArray[arrayPointer] = []
      for(let i = 0; i < state.currentMonth.days; i++){
        //console.log(count % 7 === 0)
        if (count < 7){
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }else if (count % 7 === 0){
          arrayPointer++
          state.currentMonthArray[arrayPointer] = []
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        } else{
          state.currentMonthArray[arrayPointer].push({
            dayNumber: count,
            type: "link",
            day: (monthNum++) + 1
          })
          count++
        }
      }
    }
  },
    getBanners(state){
        axios({
            method: 'get',
            url: state.newRootUrl + 'web-banners',
            //headers: {'Authorization': 'Bearer '+ Vue.localStorage.get('token') },
        })
            .then(response => {

                if (response.status === 200 ){
                    state.WebBannersList =[]
                    /*console.log(response.data)
                    for (let i = 0; i< response.data.WebBanners.length; i++){
                        state.WebBannersList.push(response.data.WebBanners[i])
                    }*/
                    state.WebBannersList = response.data
                }
                else{
                    console.log('1')
                }
            })
            .catch(err => {
                console.log('2')
            })
    },
  setKeywordResult(state, payload){

          state.KeywordResults =[]
          for (let i = 0; i< payload.data.Keyword.length; i++){
            state.KeywordResults.push(payload.data.Keyword[i])
          }

  },
  setDegreeList(state, payload){
    state.undergradDegrees = []
    state.undergradDegrees = payload
  },
  setGradDegreeList(state, payload){
    state.gradDegrees = []
    state.gradDegrees = payload
  },

  setTEDDegreeList(state, payload){
    state.undergradTedDegrees = []
    let q = payload.data.Degrees
    console.log(q)
    for(let i =0; i < q.length; i++){
      let k = {}

      k.degreeName = q[i].degreeName
      k.Department = q[i].Department
      k.id = q[i]._id
      //k.bachelor_science = q[i].acf.bachelor_science
      k.levelsOffered = q[i].levelsOffered
      k.thumbnailImage = q[i].thumbnailImage

      k.associate_arts = q[i].associate_arts
      k.associate_science = q[i].associate_science
      k.bachelor_arts = q[i].bachelor_arts
      k.bachelor_science = q[i].bachelor_science
      k.department = q[i].department
      k.college = q[i].collegeName

      state.undergradTedDegrees.push(k)
    }
  },
    setCNASDegreeList(state, payload){
    state.undergradCNASDegrees = []
    let q = payload.data.Degrees
    console.log(q)
    for(let i =0; i < q.length; i++){
      let k = {}

      k.degreeName = q[i].degreeName
      k.Department = q[i].Department
      k.id = q[i]._id
      //k.bachelor_science = q[i].acf.bachelor_science
      k.levelsOffered = q[i].levelsOffered
      k.thumbnailImage = q[i].thumbnailImage

      k.associate_arts = q[i].associate_arts
      k.associate_science = q[i].associate_science
      k.bachelor_arts = q[i].bachelor_arts
      k.bachelor_science = q[i].bachelor_science
      k.department = q[i].department
      k.college = q[i].collegeName

      state.undergradTedDegrees.push(k)
    }
  },

  setRandomDegreeList(state, payload){
    state.randomDegrees = []
    let q = payload.data.Degrees
      console.log(q)
    for(let i =0; i < q.length; i++){
      let k = {}

      k.degreeName = q[i].degreeName
      k.Department = q[i].Department
      k.id = q[i]._id

      //k.bachelor_science = q[i].acf.bachelor_science
      k.levelsOffered = q[i].levelsOffered
      k.thumbnailImage = q[i].thumbnailImage

      k.associate_arts = q[i].associate_arts
      k.associate_science = q[i].associate_science
      k.bachelor_arts = q[i].bachelor_arts
      k.bachelor_science = q[i].bachelor_science
      k.department = q[i].department
      k.college = q[i].collegeName

      state.randomDegrees.push(k)
       // console.log(state.randomDegrees.length)
    }
  },
  singleUndergrad(state, payload){
    state.undergradDegree = []
    state.undergradDegree = payload
  },
  sportscores(state, payload){
    state.sportsScores = []
    for(let item in payload.data.data.order){
      let img = `data:${payload.data.data.tally[item].mime_type};base64, ${payload.data.data.tally[item].crest}`;
      state.sportsScores.push({
        name: item,
        points: payload.data.data.order[item],
        crest: img
      });
    }
    //state.undergradDegree.push(k)
  }

}
